import React from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2 } from 'lucide-react';

const PropertyMobileListCard = ({ property, onDelete }) => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="flex flex-col sm:flex-row">
        {property.images && property.images[0] && (
          <div className="flex-shrink-0 w-full sm:w-1/3 relative">
            <img
              src={property.images[0]?.url}
              alt={property.title}
              className="w-full h-48 sm:h-auto object-cover"
            />
            {/* Featured Badge */}
            {property.featured && (
              <span className="absolute top-2 left-2 bg-yellow-400 text-black text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                FEATURED
              </span>
            )}
          </div>
        )}
        <div className="p-4 flex-grow flex flex-col justify-between">
          <div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1">
              {property.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              <span className="font-medium">{property.bedrooms} Beds</span> · <span className="font-medium">{property.bathrooms} Baths</span>
            </p>
            <p className="text-md text-gray-700 dark:text-gray-300 mb-2">
              {property.location}, {property.city}
            </p>
          </div>
          <div className="flex items-center justify-between mt-auto pt-3 border-t border-gray-100 dark:border-gray-700">
            <span
              className={`text-xs font-semibold px-2 py-1 rounded-full ${
                property.status === 'available'
                  ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-300'
                  : property.status === 'pending'
                  ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-300'
                  : 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-300'
              } capitalize`}
            >
              {property.status === 'available' ? 'For Sale' : property.status}
            </span>
            <span className="text-lg font-bold text-accent dark:text-accent">
              ₹ {property.price.toLocaleString()}
            </span>
          </div>
          <p className="text-sm text-gray-800 dark:text-gray-200 capitalize">
            Type: <span className="font-semibold">{property.property_type}</span>
          </p>
          <div className="flex justify-end space-x-2 mt-3">
            <Link
              to={`/aadashmin/properties/${property.id}/edit`}
              className="text-accent hover:text-accent dark:text-accent dark:hover:text-accent p-2 rounded-full hover:bg-accentdark:hover:bg-accent transition-colors duration-200"
              title="Edit Property"
            >
              <Edit className="h-5 w-5" />
            </Link>
            <button
              onClick={() => onDelete(property.id)}
              className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-200 p-2 rounded-full hover:bg-red-50 dark:hover:bg-red-900 transition-colors duration-200"
              title="Delete Property"
            >
              <Trash2 className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyMobileListCard;